import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {RiskScore} from "@advthreat/ribbon-components";
import {ADotLoader} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setIncidentMitreTactics} from "store/features/mitreSlice";
import {
  selectIncidentTactics,
  selectIncidentTacticsLoading,
  selectIncidentTacticsLoadingId
} from "store/selectors/mitreSelectors";
import {FEATURE} from "api/telemetry/";
import css from "./MitreWidget.module.scss";

const MitreWidget = ({className, incident, labelProps}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {id, tactics} = incident;
  const tacticsList = useSelector(selectIncidentTactics);
  const mitreLoading = useSelector(selectIncidentTacticsLoading);
  const mitreLoadingId = useSelector(selectIncidentTacticsLoadingId);
  // Checks the id for correct loading state in when there's multiple on same page
  const isLoading = mitreLoading && mitreLoadingId === id;

  useEffect(() => {
    dispatch(setIncidentMitreTactics({id}));
  }, [dispatch, id]);

  return (
    <div
      className={classNames(css.mitreWidget, className)}
      data-testid={"MitreWidget-Container"}>
      <div className="mr-1" {...labelProps}>
        {t("incidentDetail.detail.mitreTitle")}
      </div>
      {/* Widget will only show if tactics exist */}
      {tactics?.length > 0 ? (
        isLoading ? (
          <ADotLoader size="small" className="ma-0" />
        ) : (
          <RiskScore
            tacticsList={tacticsList}
            popoverOptions={{placement: "right-start", appendTo: document.body}}
            telemetryLocationKey={FEATURE.INCIDENT_DETAIL.MITRE_WIDGET}
          />
        )
      ) : (
        <span>{t("drawers.labels.common.emptyTitle")}</span>
      )}
    </div>
  );
};

MitreWidget.propTypes = {
  className: PropTypes.string,
  /**
   * Option to pass props to the label "MITRE:"
   */
  labelProps: PropTypes.object,
  incident: PropTypes.object
};

export default MitreWidget;
